import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { withCart } from '../../utils/CartContext';
import _ from '../../utils/LodashImports';
import { withProduct } from '../../utils/ProductContext';
import { withUser } from '../../utils/UserContext';
import RatingAndReviewsStyles from './RatingAndReviews.style';

const RatingStars = dynamic(() => import('@digital-retail/rating-and-reviews').then((lib) => lib.RatingStars), {
  ssr: false,
  loading: () => '',
});

const RatingAndReviews = ({ appCtx }) => {
  const isRatingsShownInPDP = _.get(appCtx, 'siteConfig.toggles.isRatingsShownInPDP', true);
  if (!isRatingsShownInPDP) {
    return null;
  }

  const isInHouseReviewSectionEnabled = _.get(appCtx, 'siteConfig.toggles.isInHouseReviewSectionEnabled', false);

  const handleStarsClick = () => {
    const elementId = isInHouseReviewSectionEnabled ? 'InHouseReviewsContainer-PDP' : 'BVRRSearchContainer';
    const element = document.getElementById(elementId);

    if (element) {
      // Calculate the Y coordinate of the element relative to the document
      const elementY = element.getBoundingClientRect().top + window.scrollY;
      // Scroll to the element
      window.scrollTo({
        top: elementY,
        behavior: 'smooth', // You can use 'auto' or 'smooth' for smooth scrolling
      });
    }
  };

  return (
    <div className="rr-wrapper">
      <div aria-hidden="true" onClick={handleStarsClick} className="rr-rating-stars" data-testid="rr-rating-stars">
        <RatingStars />
      </div>
      <style jsx>{RatingAndReviewsStyles}</style>
    </div>
  );
};

RatingAndReviews.defaultProps = {
  appCtx: {},
};

RatingAndReviews.propTypes = {
  appCtx: PropTypes.object,
};

const RARWithContext = withApplicationContext(withCart(withUser(withProduct(RatingAndReviews))));
export { RARWithContext as RatingAndReviews };
